import React from 'react'
import { ArticleHeadingWidget } from 'components/Widgets/ArticleHeadingWidget'
import { prepareGetStaticNavigationProps } from 'routes/utils/prepareGetStaticNavigationProps'
import { getPublicLayout } from './components/PublicLayout'

export const TheExpertsNextChapter = () => (
  <div>
    <ArticleHeadingWidget
      title="The Expert's Next Act: New Industry-Defining Tools, Same Mission"
      author="Lee Anne Blake"
    />

    <div
      style={{
        fontFamily: 'Lora, serif',
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        fontWeight: 400,
      }}
    >
      <p>
        Today marks an exciting milestone for The Expert:{' '}
        <b>we&apos;ve been acquired by Havenly Brands</b>, joining their
        portfolio of design-forward brands.
      </p>
      <p>&nbsp;</p>
      <p>
        It&apos;s a big moment for our team—and a meaningful step toward
        building more tools, access, and support to serve designers even better.
        Since launching The Expert in 2020, our mission has always been to
        champion the creative voices driving the home industry.
      </p>
      <p>&nbsp;</p>
      <p>
        We started with consultations, building a roster of the most exciting
        interior designers—from industry titans to emerging talent—and offering
        fractional access to their expertise for the first time. From the
        beginning, the response from both designers and clients was
        overwhelming. We knew we were onto something.
      </p>
      <p>&nbsp;</p>
      <p>
        Our next frontier was e-commerce, quickly embraced by the design
        community and brought to life through our trade program. What began as a
        curated marketplace of industry-loved brands has grown into a go-to
        resource for designers everywhere.
      </p>
      <p>&nbsp;</p>
      <p>
        Along the way, we&apos;ve connected with thousands of trade members,
        learned their pain points firsthand, and focused on solving them brick
        by brick.
      </p>
      <p>&nbsp;</p>
      <p>
        Over the past year, we launched our Price Match Promise, so trade
        members can shop confidently knowing they&apos;ll get the same designer
        discount they would going direct—while checking out across hundreds of
        brands in one cart. We introduced a quote tool to make large and custom
        orders easier to manage. We expanded our brand and vintage offerings to
        better serve different budgets, timelines, and design briefs. And we
        rolled out new filters and favorites that cut down sourcing time and
        make it easier to get back to designing.
      </p>
      <p>&nbsp;</p>
      <p>All of this is to say: we&apos;re just getting started!</p>
      <p>&nbsp;</p>
      <p>
        We&apos;re incredibly proud of what we&apos;ve built as an independent
        company.{' '}
        <b>
          But to fully realize our ambitions of becoming the definitive platform
          for interior designers, we knew we needed greater resources.
        </b>
      </p>
      <p>&nbsp;</p>
      <p>
        <b>
          We first met Lee Mayer, CEO of Havenly Brands in 2025, and it was
          immediately clear how complementary our companies were. Havenly brings
          scale, infrastructure, and proprietary technology. The Expert brings
          cultural credibility, taste leadership, and deep relationships within
          the trade community. Together, we believe this team is uniquely
          positioned to make industry-defining improvements to the way designers
          work.
        </b>
      </p>
      <p>&nbsp;</p>
      <p>
        Today, we celebrate five years of building independently—and extend our
        sincere gratitude to the Experts, trade members, and brand partners who
        helped us get here. Tomorrow, we get back to work on what matters most:
        bringing together the best Experts, brands, trade benefits, and
        post-sale service the industry has to offer, all powered by technology
        that actually makes a difference.
      </p>
      <p>&nbsp;</p>
      <h2 style={{ fontSize: '2.25rem' }}>Looking Ahead</h2>
      <p>
        This acquisition positions us to build the operating backbone for design
        firms today: supporting creativity, reducing operational friction, and
        honoring what matters most: the designer&apos;s craft.
      </p>
      <p>&nbsp;</p>
      <p>
        In Spring 2026, we plan to unveil a significant new, designer-first
        offering that brings sourcing, technology, and services together in a
        way the industry hasn&apos;t seen before. Thanks for building with us—we
        can&apos;t wait to show you what&apos;s next.
      </p>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </div>
    <div
      style={{
        position: 'relative',
        paddingTop: '56.25%',
        aspectRatio: '1/1',
        maxWidth: 720,
        margin: 'auto',
      }}
    >
      <iframe
        src="https://iframe.mediadelivery.net/embed/3516/9ddd3d6f-14ce-42b9-87c2-a4f8c2b5bbd5?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
        loading="lazy"
        title="The Expert’s Next Act: New Industry-Defining Tools, Same Mission"
        style={{
          border: 0,
          position: 'absolute',
          top: 0,
          height: '100%',
          width: '100%',
        }}
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowFullScreen
      />
    </div>

    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
  </div>
)

export function getStaticProps() {
  return prepareGetStaticNavigationProps()
}

TheExpertsNextChapter.getLayout = getPublicLayout
